// 项目常量配置
export default class AppConstants {
  /**
   * 通过值获取名字
   * @param code 具体值
   * @param typeList  要查找的数据列表
   * @returns {string|*}
   */
  /**
   * 最全商品类型
   */
  static getAllProductTypeList() {
    return [
      {
        name: '酒店',
        code: 2
      },
      {
        name: '门票',
        code: 1
      },
      {
        name: '抢购',
        code: 8
      },
      {
        name: '国内跟团',
        code: 74
      },
      {
        name: '出境跟团',
        code: 73
      },
      {
        name: '签证',
        code: 3
      },
      {
        name: '景酒',
        code: 4
      },
      {
        name: '百货',
        code: 5
      },
      {
        name: '机票',
        code: 6
      },
      {
        name: '火车票',
        code: 7
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/appConstants.js